import axios from "axios";
import { BASE_URL, CREATE_ORDER,CREATE_ORDER_PIX, VALIDATE_PAYMENT } from "../endpoints/endpoints";

function basePaymentData(data) {
    let endereco = data.endereco
    let usuario = data.usuario
    let product = data.product

    const isBR = endereco.country === 'BR';
    usuario.country_code_phone = _setCountryCode(usuario.phone, isBR).replace("+", "");
    usuario.area_code_phone = _setAreaCode(usuario.phone, isBR);
    usuario.phone_number = _setPhoneNumber(usuario.phone, isBR);

    let postData = {
        "product_db": product,
        "product": {
            "id": product.id,
            "amount": product.amount,
            "description": product.description,
            "name": product.name,
            "split_rules": product.split_rules
        },
        "customer": {
            "name": usuario.nome,
            "email": usuario.email,
            "cpf": usuario.document,
            "phone": usuario.phone,
            "area_code_phone": usuario.area_code_phone,
            "country_code_phone": usuario.country_code_phone,
            "phone_number": usuario.phone_number
        },
        "address": {
            "line_1": `${endereco.rua}, ${endereco.bairro}, ${endereco.numero}`,
            "zip_code": endereco.cep,
            "city": endereco.cidade,
            "province": endereco.estado,
            "country": endereco.country
        },
        "items": [
            {
                "amount": product.amount,
                "description": product.description,
                "quantity": product.quantity,
                "code": product.code,
            },
        ]
    };

    return postData
}

export async function PaymentCardCredit(data, onError, onStatus) {
    let url = BASE_URL + CREATE_ORDER;
    const dataBase = basePaymentData(data);
    let productSplitRules = data.product.split_rules;

    //* Cartao
    let cartao = data.cartao;
    let validateCardCredit = cartao.validade_cartao.split("/")
    let exp_month = parseInt(validateCardCredit.length > 0 ? validateCardCredit[0] : '0');
    let exp_year = parseInt(validateCardCredit.length > 1 ? validateCardCredit[1] : '0');

    cartao.numero_cartao = cartao.numero_cartao.replace(/\D/g, '');

    let postData = {
        ...dataBase,
        cartao: cartao,
        "payments": [
            {
                "split_rules": productSplitRules,
                "payment_method": "credit_card",
                "credit_card": {
                    "number": cartao.numero_cartao,
                    "holder_name": cartao.nome_cartao,
                    "exp_month": exp_month,
                    "exp_year": exp_year,
                    "cvv": cartao.cvv,
                    "installments": cartao.installments,
                    "totalValue": cartao.totalValue,
                }
            }
        ]
    };

   const dataData = { "data": postData }

    await axios.post(url, dataData).then((response) => {
        if (!response) {
            onError();
            return;
        }


        const data = response.data;

        const status = data.status

        onStatus(status);
    }).catch((error) => {
            console.error('Error:', error);

            if (!error.response || !error.response.data) {
                onError('Erro ao criar pedido')
                return
            } else {
                // Tenta extrair a mensagem de erro do servidor
                const responseData = error.response.data;
                let message = 'Erro ao processar pagamento';
                
                if (responseData && responseData.message) {
                    if (responseData.message.errors && responseData.message.errors.length > 0) {
                        // Se há erros estruturados, pega a descrição do primeiro erro
                        message = responseData.message.errors[0].description;
                    } else if (typeof responseData.message === 'string') {
                        // Se a mensagem é uma string simples
                        message = responseData.message;
                    }
                }
                
                onError(message);
            }
    });
}

export async function CreateOrderPix(data, onError, onStatus) {
    let url = BASE_URL + CREATE_ORDER_PIX;
    let product = data.product
    let productSplitRules = data.product.split_rules

    const dataBase = basePaymentData(data);

    let postData = {
        ...dataBase,
        "payments": [
            {
                "split_rules": productSplitRules,
                "payment_method": "pix",
                "pix": {
                    "expires_in": 7200,
                    "amount": product.amount,
                    "name": product.description,
                    "value": product.quantity.toString(),
                }
            }
        ]
    };

    const dataData = { "data": postData }

    await axios.post(url, dataData).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const data = response.data;

        const status = data.status;
        const closed = false;
        const orderId = data.id;
        const pixCode = data.pixCode;

        onStatus(status, closed, orderId, pixCode);
    }).catch((error) => {
        if (!error.response || !error.response.data) {
            onError('Erro ao criar pedido')
            return
        } else {
            // Tenta extrair a mensagem de erro do servidor
            const responseData = error.response.data;
            let message = 'Erro ao processar pagamento';
            
            if (responseData && responseData.message) {
                if (responseData.message.errors && responseData.message.errors.length > 0) {
                    // Se há erros estruturados, pega a descrição do primeiro erro
                    message = responseData.message.errors[0].description;
                } else if (typeof responseData.message === 'string') {
                    // Se a mensagem é uma string simples
                    message = responseData.message;
                }
            }
            
            onError(message);
        }
    });
}

export async function ValidatePix(orderId, onError, onStatus) {

    let url = BASE_URL + VALIDATE_PAYMENT + orderId;


    await axios.get(url).then((response) => {
        if (!response) {
            onError();
            return;
        }

        const responseData = response.data;

        const status = responseData.status;
        const closed = false;
        const orderId = responseData.id;
        const pixCode = responseData.pixCode;

        onStatus(status, closed, orderId, pixCode);
    }).catch((error) => {
        console.error('Error:', error);

        if (!error.response || !error.response.data) {
            onError('Erro ao validar pagamento')
            return
        } else {
            // Tenta extrair a mensagem de erro do servidor
            const responseData = error.response.data;
            let message = 'Erro ao validar pagamento';
            
            if (responseData && responseData.message) {
                if (responseData.message.errors && responseData.message.errors.length > 0) {
                    // Se há erros estruturados, pega a descrição do primeiro erro
                    message = responseData.message.errors[0].description;
                } else if (typeof responseData.message === 'string') {
                    // Se a mensagem é uma string simples
                    message = responseData.message;
                }
            }
            
            onError(message);
        }
    });
}

function _setCountryCode(phone, IsBR = true) {
    phone = phone.replace(" ", "");
    let countryCodeE = '';

    const index = phone.indexOf(")")

    if (index > 0) {
        countryCodeE = phone.substring(0, IsBR ? index - 3 : index - 4);
    }

    return countryCodeE;
}

function _setAreaCode(phone, IsBR = true) {
    let phoneAreaCode = '';

    const index = phone.indexOf("(");

    if (index > 0) {
        phoneAreaCode = phone.substring(index + 1, IsBR ? index + 3 : index + 4);
    }

    return phoneAreaCode;
}

function _setPhoneNumber(phone, IsBR = true) {
    let phoneNumber = '';

    phone = phone.replace(" ", "");
    phone = phone.replace("-", "");
    phone = phone.replace("  ", "");

    const index = phone.indexOf(")");

    if (index > 0) {
        phoneNumber = phone.substring(index + 1, phone.length);
    }

    phoneNumber = phoneNumber.replace(" ", "");
    phone = phone.replace("  ", "");
    phone = phone.replace("_", "");

    return phoneNumber;
}